// set on .maptive.com by the "Attribution cookie" GTM tag: campaign, ad click ids, referrer and landing page of the visit
const ATTRIBUTION_COOKIE = 'mt_attribution';
// set on .maptive.com by the Google Ads conversion linker after an ad click, e.g. "GCL.1791406825.<gclid>"
const GOOGLE_ADS_CLICK_COOKIE = '_gcl_aw';

const ATTRIBUTION_KEYS = [
  'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content',
  'gclid', 'gbraid', 'wbraid', 'msclkid',
  'referrer', 'landing_page', 'date',
] as const;

export type SignupAttribution = Partial<Record<typeof ATTRIBUTION_KEYS[number] | 'gcl_aw', string>>;

const readCookie = (name: string): string | undefined =>
  document.cookie
    .split('; ')
    .find(cookie => cookie.startsWith(`${name}=`))
    ?.slice(name.length + 1);

const parseAttributionCookie = (value: string | undefined): SignupAttribution => {
  if (!value) {
    return {};
  }

  try {
    const parsed: unknown = JSON.parse(decodeURIComponent(value));
    if (!parsed || typeof parsed !== 'object') {
      return {};
    }

    return ATTRIBUTION_KEYS.reduce<SignupAttribution>((result, key) => {
      const keyValue = (parsed as Record<string, unknown>)[key];
      return typeof keyValue === 'string' && keyValue ? { ...result, [key]: keyValue } : result;
    }, {});
  }
  catch {
    return {};
  }
};

// where the visitor came from before signing up, sent with the sign up so the BE can store it on the new account
export const getSignupAttribution = (): SignupAttribution | undefined => {
  const attribution = parseAttributionCookie(readCookie(ATTRIBUTION_COOKIE));
  const googleAdsClick = readCookie(GOOGLE_ADS_CLICK_COOKIE);
  const result: SignupAttribution = googleAdsClick ? { ...attribution, gcl_aw: googleAdsClick } : attribution;

  return Object.keys(result).length ? result : undefined;
};

// the SSO callbacks are GET requests and apiGet does not encode the query values
export const getSignupAttributionQueryParam = (): string | undefined => {
  const attribution = getSignupAttribution();
  return attribution ? encodeURIComponent(JSON.stringify(attribution)) : undefined;
};
